import Vue from 'vue'
import App from './App.vue'
import Logo from './Logo.vue'
import HoeflerMap from './HoeflerMap.vue'
import Lagenkarte from './Lagenkarte.vue'
import VueTimers from 'vue-timers'
import VueWaypoint from 'vue-waypoint'

Vue.config.productionTip = false;
Vue.use(VueTimers);
Vue.use(VueWaypoint);

//  for dev purpose
new Vue({
  render: h => h(App),
}).$mount('#app')


// mount vue logo app
new Vue({
  render: h => h(Logo),
}).$mount('#vue-logo')

// mount vue map app
new Vue({
  render: h => h(HoeflerMap),
}).$mount('#vue-map')

// mount vue map app
new Vue({
  render: h => h(Lagenkarte),
}).$mount('#vue-lagenkarte')

// mount all vue masks
const masks = [ ...document.querySelectorAll('.mask') ];
masks.forEach( mask => {

  new Vue({
    render: h => h(App)
  }).$mount( mask );

});